<template>
    <div class="container operator-index-container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="card-header-label col-2">
                        <span
                            class="mdi mdi-account-hard-hat custom-icon"
                        ></span>
                        <span>Operarios</span>
                    </div>
                    <div class="card-header-search-bar col-5">
                        <b-form-input
                            v-model="filter"
                            id="filter-input"
                            placeholder="Escriba aquí el texto a buscar"
                        >
                        </b-form-input>
                    </div>
                    <div class="card-header-pagination col-3">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="filteredList ? filteredList.length : 0"
                            :per-page="perPage"
                            aria-controls="list-table"
                            style="margin: 0"
                            align="center"
                        >
                        </b-pagination>
                    </div>
                    <div class="card-header-action-buttons col-2">
                        <div>
                            <ButtonComponent
                                :buttonText="'Nuevo'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="openCreateModal"
                            />
                            <ButtonComponent
                                :buttonText="'Refrescar'"
                                :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="getList"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isLoading" style="padding: 5ch 0">
                <SpeenComponent
                    :isAutomatic="true"
                    :ringWidth="14"
                    :spinnerSize="15"
                    :isverticalAligned="true"
                />
            </div>
            <div class="card-body" v-else>
                <b-table
                    :items="filteredList"
                    :fields="fields"
                    small
                    striped
                    hover
                    :per-page="perPage"
                    :current-page="currentPage"
                    id="list-table"
                >
                    <template #cell(actions)="data">
                        <ButtonComponent
                            :buttonText="'Editar'"
                            :buttonColor="colors.GREEN_COLOR_BUTTON"
                            :buttonAction="() => openEditModal(data.item)"
                        />
                        <ButtonComponent
                            :buttonText="'Borrar'"
                            :buttonColor="colors.RED_COLOR_BUTTON"
                            :buttonAction="() => confirmDeleteItem(data.item)"
                        />
                    </template>
                </b-table>
            </div>
        </div>
        <transition name="slide-fade">
            <OperatorCreateModal
                v-if="showCreateModal"
                @close-modal="closeCreateModal"
                @operator-created="getList"
            />
            <OperatorEditModal
                v-if="showEditModal"
                :operatorId="currentItemId"
                @close-modal="closeEditModal"
                @operator-edited="getList"
            />
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="actionConfirmModalMessage"
                :closeModal="closeActionConfirmModal"
                :methodForProp="methodForProp"
            />
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from "../../common/utils";
import OperatorCreateModal from "../components/OperatorCreateModal.vue";
import OperatorEditModal from "../components/OperatorEditModal.vue";
import ButtonComponent from "../../common/components/ButtonComponent.vue";
import Colors from "../../common/colors";
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import { filterList } from "../../common/utils";

export default {
    name: "OperatorIndexComponent",
    components: {
        SpeenComponent,
        OperatorCreateModal,
        OperatorEditModal,
        ButtonComponent,
        ActionConfirmModal,
    },
    data() {
        return {
            colors: Colors,
            perPage: 10,
            currentPage: 1,
            filter: '',
            listData: [],
            isLoading: true,
            showCreateModal: false,
            showEditModal: false,
            showActionConfirmModal: false,
            currentItemId: -1,
            actionConfirmModalMessage: '',
            methodForProp: null,
            fields: [
                { key: "name",              label: "Nombre",    sortable: true, class: "truncate" },
                { key: "surname",           label: "Apellido",  sortable: true, class: "truncate" },
                { key: "email",             label: "Correo",    sortable: true, class: "truncate" },
                { key: "title_descrip",     label: "Puesto",    sortable: true, class: "truncate" },
                { key: "actions",           label: "Ajustes",   sortable: false, class: "truncate"},
            ],
        };
    },
    computed: {
        filteredList: function () {
            return filterList(this.listData, this.fields, this.filter);
        },
    },
    methods: {
        getList() {
            this.isLoading = true;
            axios.get("/api/operator")
                .then((response) => {
                    this.listData = response.data;
                })
                .catch((error) => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        openCreateModal() {
            this.showCreateModal = true;
        },
        closeCreateModal() {
            this.showCreateModal = false;
        },
        openEditModal(clikckedItem) {
            this.currentItemId = clikckedItem.id;
            this.closeEditModal();
        },
        closeEditModal() {
            this.showEditModal = false;
        },
        confirmDeleteItem(operator) {
            this.actionConfirmModalMessage = `¿Está seguro de que desea eliminar el operador ${operator.name} ${operator.surname}?`;
            this.methodForProp = () => {
                this.deleteItem(operator);
            };
            this.openActionConfirmModal();
        },
        deleteItem(item) {
            axios
                .delete(`/api/operator/${item.id}`)
                .then(() => {
                    showCustomSuccessSweetAlert("Operario eliminado correctamente");
                    this.getList();
                })
                .catch((error) => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.closeActionConfirmModal();
                });
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    mounted() {
        this.getList();
    },
};
</script>